import type { FunctionComponent } from 'react';

import { Badge, Tooltip } from '@mantine/core';

import {
  MAPPING_BADGE_LABEL,
  MAPPING_DESCRIPTION,
  MAPPING_STATUS,
  formatMissingPosId,
} from 'constants/mapping';

import { BlockIconSm, CheckIconSm } from '@chownow/pantry/icons';

type MappingBadgeProps = {
  status: string;
  externalId?: string;
};

export const MappingBadge: FunctionComponent<MappingBadgeProps> = ({ status, externalId }) => {
  switch (status) {
    case MAPPING_STATUS.MAPPED:
      return (
        <Tooltip label={MAPPING_DESCRIPTION.MAPPED}>
          <Badge variant="success" size="xs">
            {MAPPING_BADGE_LABEL.MAPPED}
          </Badge>
        </Tooltip>
      );
    case MAPPING_STATUS.STAGED_MAPPED:
      return (
        <Tooltip label={MAPPING_DESCRIPTION.EDITED_MAPPED}>
          <Badge variant="yellow" size="xs" leftSection={<CheckIconSm />}>
            {MAPPING_BADGE_LABEL.EDITED}
          </Badge>
        </Tooltip>
      );
    case MAPPING_STATUS.STAGED_UNMAPPED:
      return (
        <Tooltip label={MAPPING_DESCRIPTION.EDITED_UNMAPPED}>
          <Badge variant="yellow" size="xs" leftSection={<BlockIconSm />}>
            {MAPPING_BADGE_LABEL.EDITED}
          </Badge>
        </Tooltip>
      );
    case MAPPING_STATUS.POS_MISSING:
      return (
        <Tooltip label={formatMissingPosId(externalId)}>
          <Badge variant="caution" size="xs">
            {MAPPING_BADGE_LABEL.POS_MISSING}
          </Badge>
        </Tooltip>
      );
    case MAPPING_STATUS.UNMAPPED:
    // purposely fall-through
    // eslint-disable-next-line no-fallthrough
    default:
      return (
        <Tooltip label={MAPPING_DESCRIPTION.UNMAPPED}>
          <Badge variant="gray" size="xs">
            {MAPPING_BADGE_LABEL.UNMAPPED}
          </Badge>
        </Tooltip>
      );
  }
};
